import template from './loader.dot';
const loaderTemplate = template.default ? template.default : template;
export { loaderTemplate };
